
export interface GuideTopic {
  name: string;
  source: string;
}

export interface GuideCategory {
  id: string;
  name: string;
  icon: 'Cardiology' | 'Respiratory' | 'Endocrinology' | 'Rheumatology' | 'Dermatology' | 'Eyes' | 'Gastroenterology' | 'Neurology' | 'Psychiatry' | 'Urology' | 'Nephrology' | 'OBGYN' | 'InfectiousDisease' | 'Oncology';
  topics: GuideTopic[];
}

export const clinicalGuidesData: GuideCategory[] = [
  {
    id: 'cardiology',
    name: 'Cardiology',
    icon: 'Cardiology',
    topics: [
      { name: 'Hypertension (HTN)', source: 'ACC/AHA' },
      { name: 'Dyslipidemia', source: 'ACC/AHA' },
      { name: 'Heart Failure (HF)', source: 'ACC/AHA/HFSA' },
      { name: 'Atrial Fibrillation (AFib)', source: 'ACC/AHA/HRS' },
      { name: 'Acute Coronary Syndrome (ACS)', source: 'ACC/AHA' },
      { name: 'Stable Ischemic Heart Disease (SIHD)', source: 'ACC/AHA' },
      { name: 'Venous Thromboembolism (VTE)', source: 'CHEST' },
      { name: 'Peripheral Arterial Disease (PAD)', source: 'ACC/AHA' },
    ],
  },
  {
    id: 'respiratory',
    name: 'Respiratory',
    icon: 'Respiratory',
    topics: [
      { name: 'Asthma', source: 'GINA' },
      { name: 'COPD', source: 'GOLD' },
      { name: 'Community-Acquired Pneumonia (CAP)', source: 'IDSA/ATS' },
    ],
  },
  {
    id: 'endocrinology',
    name: 'Endocrinology',
    icon: 'Endocrinology',
    topics: [
      { name: 'Type 2 Diabetes (T2DM)', source: 'ADA' },
      { name: 'Thyroid Disease', source: 'ATA' },
      { name: 'Osteoporosis', source: 'AACE/ACE' },
    ],
  },
  {
    id: 'rheumatology',
    name: 'Rheumatology / Musculoskeletal',
    icon: 'Rheumatology',
    topics: [
        { name: 'Rheumatoid Arthritis', source: 'ACR' },
        { name: 'Gout', source: 'ACR' },
    ]
  },
  {
    id: 'neurology',
    name: 'Neurology',
    icon: 'Neurology',
    topics: [
        { name: 'Ischemic Stroke & TIA', source: 'AHA/ASA' },
        { name: 'Epilepsy & Seizures', source: 'AES' },
        { name: 'Parkinson\'s Disease', source: 'MDS' },
        { name: 'Multiple Sclerosis', source: 'AAN' },
    ]
  },
    {
    id: 'psychiatry',
    name: 'Psychiatry',
    icon: 'Psychiatry',
    topics: [
        { name: 'Major Depressive Disorder (MDD)', source: 'APA' },
        { name: 'Bipolar Disorder', source: 'APA' },
        { name: 'Schizophrenia', source: 'APA' },
        { name: 'Generalized Anxiety Disorder (GAD)', source: 'APA' },
    ]
  },
   {
    id: 'infectiousdisease',
    name: 'Infectious Disease',
    icon: 'InfectiousDisease',
    topics: [
        { name: 'Antimicrobial Stewardship', source: 'IDSA' },
        { name: 'Sepsis & Septic Shock', source: 'Surviving Sepsis Campaign' },
        { name: 'HIV/AIDS', source: 'DHHS' },
        { name: 'Urinary Tract Infections (UTI)', source: 'IDSA' },
    ]
  },
];
